import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Dialog, DialogTrigger, DialogContent, DialogClose } from "@tenant/ui";
import styles from "./styles.module.scss";

interface DeleteTravelerDialogProps extends PlatformComponentProps {
  text?: { title?: string; description?: string };
  trigger: React.ReactElement;
  onConfirmDelete: () => void;
}

export const DeleteTravelerDialog: React.FC<DeleteTravelerDialogProps> = ({
  text: { title, description } = { title: "", description: "" },
  trigger,
  onConfirmDelete,
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "DeleteTravelerModal");

  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>

      <DialogContent className={block} fullScreen showCloseButton={false}>
        <div className={cn("container")}>
          <div className={cn("content")}>
            <div className={cn("title")}>
              {title || t("checkoutSection.deleteTravelerDialog.title")}
            </div>
            <span className={cn("description")}>
              {description ||
                t("checkoutSection.deleteTravelerDialog.description")}
            </span>
          </div>

          <div className={cn("actions")}>
            <DialogClose className={cn("cancel-button")}>
              {t("cancel")}
            </DialogClose>

            <div className={cn("divider")} />

            <DialogClose asChild>
              <button className={cn("delete-button")} onClick={onConfirmDelete}>
                {t("delete")}
              </button>
            </DialogClose>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
